/** @override King Living: BaseLinkFragment with __typename so Component wrapper can resolve Link entries. */

import gql from 'graphql-tag';

export const BaseLinkFragment = gql`
  fragment BaseLinkFragment on Link {
    __typename
    sys {
      id
    }
    action
    helptext
    iconPosition
    image {
      url
      title
      description
      contentType
    }
    openInNewTab
    popupContent {
      __typename
      ... on Entry {
        sys {
          id
        }
      }
    }
    linkText: text
    totalCount
    linkType: type
    url
  }
`;
